import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { RedmineService } from 'src/app/shared/services/redmine.service';
import { RedmineIssuePost } from '../redmine.interface';
import { Router } from '@angular/router';
import { env } from 'process';
import { environment } from 'src/environments/environment';
import { AccessService } from 'src/app/core/services/access.service';

@Component({
  selector: 'egi-issue-modal',
  templateUrl: './issue-modal.component.html',
  styleUrls: ['./issue-modal.component.css'],
})
export class IssueModalComponent implements OnInit, OnChanges {
  @Input() show = false;
  @Output() close = new EventEmitter<any>();

  issue: RedmineIssuePost = {
    project_id: 0,
    tracker_id: 0,
    status_id: 0,
    priority_id: 0,
    subject: '',
    description: '',
    impact: undefined,
    operating_system: undefined,
    steps_to_reproduce: undefined,
    url: '',
    notes: '',
    category_id: undefined,
    fixed_version_id: undefined,
    assigned_to_id: undefined,
    parent_issue_id: undefined,
    custom_fields: [],
    watcher_user_ids: [],
    is_private: false,
    estimated_hours: undefined,
    attachments: [],
  };
  trackers: any[] = [];
  statuses: any[] = [];
  users: any = {};
  projects: any[] = [];
  custom_fileds: any[] = [];
  issuePriorities: any[] = [];
  issueIdx: number;
  urls = ['Current URL', 'Other URL', 'No URL'];
  urlSelect = this.urls[0];
  userSubscription$: any;
  user: any;
  errorText = '';

  loading = false;
  constructor(
    private redmine: RedmineService,
    private router: Router,
    private accessApi: AccessService,
  ) {}

  ngOnInit(): void {
    this.userSubscription$ = this.accessApi.mee.subscribe((user) => {
      this.user = user;
    });
    this.handleUrlChange(this.urlSelect);
  }

  async ngOnChanges(): Promise<void> {
    if (this.show) {
      this.issue = {
        project_id: 0,
        tracker_id: 0,
        status_id: 0,
        priority_id: 0,
        subject: '',
        description: '',
        impact: undefined,
        operating_system: undefined,
        steps_to_reproduce: undefined,
        url: '',
        notes: '',
        category_id: undefined,
        fixed_version_id: undefined,
        assigned_to_id: undefined,
        parent_issue_id: undefined,
        custom_fields: [],
        watcher_user_ids: [],
        is_private: false,
        estimated_hours: undefined,
        attachments: [],
      };
      this.errorText = '';

      this.handleUrlChange(this.urlSelect);
      const promises = [
        this.redmine.getProjects().toPromise(),
        this.redmine.getUsers(this.user.email).toPromise(),
        this.redmine.getIssueStatuses().toPromise(),
        this.redmine.getTrackers().toPromise(),
        this.redmine.getCustomFields().toPromise(),
        this.redmine.getIssuePriorities().toPromise(),
      ];
      [
        this.projects,
        this.users,
        this.statuses,
        this.trackers,
        this.custom_fileds,
        this.issuePriorities,
      ] = await Promise.all(promises);

      if (this.users.users.length > 0) {
        this.issue.watcher_user_ids = [this.users.users[0].id];
      }

      this.trackers = this.trackers.filter((t: any) => {
        const name = t.name.toLowerCase();
        return name === 'issue' || name === 'feature';
      });
      this.issueIdx = this.trackers.find(
        (x) => x.name.toLowerCase() === 'issue',
      ).id;
      this.issue.priority_id = this.issuePriorities[1].id;

      this.issue.tracker_id = this.trackers[0].id;
      this.issue.project_id = 55; // Requested Features & Reported Issues
    }
  }

  handleUrlChange(event: any): void {
    if (event === 'Current URL') {
      this.issue.url = environment.baseUrl + this.router.url;
    } else {
      this.issue.url = '';
    }
  }

  handleFileInput(event: any): void {
    this.issue.attachments = event.target.files;
  }

  handleClose(): void {
    this.close.emit('close');
  }

  handleSubmit(): void {
    this.loading = true;

    if (this.issue.subject === '' || this.issue.description === '') {
      this.errorText = 'ERROR: Title and Description are required fields';
      return;
    }

    const formData = new FormData();
    for (const file of this.issue.attachments) {
      formData.append('files', file);
    }

    formData.append('project_id', this.issue.project_id.toString());
    formData.append('tracker_id', this.issue.tracker_id.toString());
    formData.append('subject', this.issue.subject);
    formData.append('description', this.issue.description);
    formData.append('impact', this.issue.impact || '');
    formData.append('operating_system', this.issue.operating_system || '');
    formData.append('steps_to_reproduce', this.issue.steps_to_reproduce || '');
    formData.append('notes', this.issue.notes);
    formData.append('url', this.issue.url);
    formData.append('priority_id', this.issue.priority_id.toString());
    formData.append('watcher_user_ids', this.issue.watcher_user_ids.join(','));

    this.redmine.postIssue(formData).subscribe(
      (res) => {
        this.close.emit('close');
        this.loading = false;
      },
      (error) => {
        this.errorText = `ERROR: ${JSON.stringify(
          error.error.text ?? error.error,
        )}`;
        console.error('Error while submitting the issue', error);
        this.loading = false;
      },
    );
  }
}
